import {
  Form, Row, Col, Input,
} from 'antd';
import Select from 'components/Select';

import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import makeMessager from 'utils/complexFormsMessages';
import PropTypes from 'prop-types';
import { onError } from 'utils/handlers';
import { patchConfiguracionDeEntidad, getConfiguracionDeEntidad } from 'api/catalogos/configuracionDeEntidad';

export const model = 'infraccionesDeLaEntidad';

const Infracciones = ({
  setLoading,
  callback,
  setCurrentTabKey,
  setForm,
  disabled,
}) => {
  const [form] = Form.useForm();
  const _entidad = useSelector(({ auth }) => auth.entidad);

  const rules = {
    required: true,
    message: 'Este campo es obligatorio',
  };

  // eslint-disable-next-line no-use-before-define
  const showMsg = () => makeMessager(setCurrentTabKey, fetch);

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();

      const _values = {
        ...values,
        id: _entidad.id,
      };

      const request = await patchConfiguracionDeEntidad(_values);
      if (request) {
        // actualizar el local storage
        await getConfiguracionDeEntidad();
        setLoading(false);
        if (_continue) {
          showMsg();
        }
      }
      callback();
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onFinishHandler = async (tabKey = null, _continue = true) => {
    try {
      if (tabKey) {
        showMsg(tabKey);
      } else {
        await onFinish(_continue);
      }
    } catch (err) {
      onError(err);
    }
  };

  const fetch = async () => {
    try {
      form.onFinishHandler = onFinishHandler;
      setForm(form);
      form.setFieldsValue({
        id: _entidad.id,
        agente_usuario: _entidad.agente_usuario,
        aplica_a_padrones: _entidad.aplica_a_padrones,
        aplica_aqc: _entidad.aplica_aqc,
        aplica_calificar_estatus: _entidad.aplica_calificar_estatus,
        aplica_folio_manual: _entidad.aplica_folio_manual,
        aplica_fundamento_legal: _entidad.aplica_fundamento_legal,
        aplica_infraccion_peatonal: _entidad.aplica_infraccion_peatonal,
        aplica_infractor_manual: _entidad.aplica_infractor_manual,
        aplica_sectores: _entidad.aplica_sectores,
        aplica_serie: _entidad.aplica_serie,
        aplican_acuses: _entidad.aplican_acuses,
        aplican_advertencias: _entidad.aplican_advertencias,
      });
    } catch (err) {
      onError(err, setLoading);
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  return (
    <Form
      name="infraccionesConfig"
      layout="vertical"
      form={form}
      onFinish={onFinish}
      scrollToFirstError
    >
      <Row gutter={16}>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="id"
            hidden
          >
            <Input type="hidden" />
          </Form.Item>
          <Form.Item
            rules={[rules]}
            name="agente_usuario"
            label="¿Agente Usuario?"
            tooltip="Si se marca la opción, se podrá relacionar los usuarios al catálogo de agentes"
          >
            <Select
              disabled={disabled}
              trueFalse
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            rules={[rules]}
            name="aplica_a_padrones"
            label="¿Aplica a Padrones?"
            tooltip="Indicará si se usarán padrones infraccionables"
          >
            <Select
              disabled={disabled}
              trueFalse
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            rules={[rules]}
            name="aplica_aqc"
            label="¿Aplica Infracción Anónima?"
            tooltip="Determina si la infraccion puede ser anonima"
          >
            <Select
              disabled={disabled}
              trueFalse
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            rules={[rules]}
            name="aplica_calificar_estatus"
            label="¿Aplica Calificar Estatus?"
            tooltip="Aplica calificar el estatus de infracción,
              al aplicar el usuario podrá definir el rango indicado para la infracción"
          >
            <Select
              disabled={disabled}
              trueFalse
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            rules={[rules]}
            name="aplica_folio_manual"
            label="¿Aplica Folio Manual?"
            tooltip="Determina si el folio de la infraccion sera manual"
          >
            <Select
              disabled={disabled}
              trueFalse
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            rules={[rules]}
            name="aplica_fundamento_legal"
            label="¿Aplica Fundamento Legal?"
            tooltip="Determina si la infracción utiliza algun fundamento legal"
          >
            <Select
              disabled={disabled}
              trueFalse
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            rules={[rules]}
            name="aplica_infraccion_peatonal"
            label="Aplica Infracción Peatonal?"
            tooltip="Se deberá de especificar si aplicará infracciones para peatones"
          >
            <Select
              disabled={disabled}
              trueFalse
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            rules={[rules]}
            name="aplica_infractor_manual"
            label="Aplica Infractor Manual?"
            tooltip="Indica si aplicará infractor manualmente o o con relación a ciudadanos o contribuyentes"
          >
            <Select
              disabled={disabled}
              trueFalse
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            rules={[rules]}
            name="aplica_sectores"
            label="¿Aplica Sectores?"
            tooltip="Determina si la entidad maneja los sectores de las infracciones"
          >
            <Select
              disabled={disabled}
              trueFalse
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            rules={[rules]}
            name="aplican_acuses"
            label="¿Aplica Acuses?"
            tooltip="En caso de aplicar acuse, podrá utilizarse cuando
              no se tenga información del infractor, sólo se infracciona al vehículo"
          >
            <Select
              disabled={disabled}
              trueFalse
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            rules={[rules]}
            name="aplican_advertencias"
            label="¿Aplica Advertencias?"
            tooltip="En caso de requerirse se podrán aplicar advertencias,
              estas sólo se registran, pero no son cobrables, solo para historial"
          >
            <Select
              disabled={disabled}
              trueFalse
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            rules={[rules]}
            name="aplica_serie"
            label="¿Aplica Serie?"
            tooltip="Determina si aplica serie la papeleta de infracción"
          >
            <Select
              disabled={disabled}
              trueFalse
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
Infracciones.propTypes = {
  callback: PropTypes.func,
  setLoading: PropTypes.func.isRequired,
  setForm: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  setCurrentTabKey: PropTypes.func.isRequired,
};

Infracciones.defaultProps = {
  callback: () => { },
  disabled: false,
};
export default Infracciones;
